// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ByteOrder } from "./byte-order";
import { Narrow } from "./narrow";
import { Widths } from "./widths";

/**
 * A scalar read. A non-zero `any_of` reads that many equal-width flags and
 * yields 1 when any of them is set.
 */
export class ScalarDecode implements flatbuffers.IUnpackableObject<ScalarDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ScalarDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsScalarDecode(bb: flatbuffers.ByteBuffer, obj?: ScalarDecode): ScalarDecode {
    return (obj || new ScalarDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsScalarDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: ScalarDecode,
  ): ScalarDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ScalarDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  byteOrder(): ByteOrder | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  widths(): Widths {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Widths.W1;
  }

  narrow(): Narrow {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Narrow.None;
  }

  anyOf(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * With a non-zero `any_of`: accept any payload whose length is a
   * non-zero multiple of `any_of`, each flag being length / `any_of` bytes
   * wide, instead of only the widths in `widths`.
   */
  anyWidth(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startScalarDecode(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addByteOrder(builder: flatbuffers.Builder, byteOrder: ByteOrder) {
    builder.addFieldInt8(0, byteOrder, null);
  }

  static addWidths(builder: flatbuffers.Builder, widths: Widths) {
    builder.addFieldInt8(1, widths, Widths.W1);
  }

  static addNarrow(builder: flatbuffers.Builder, narrow: Narrow) {
    builder.addFieldInt8(2, narrow, Narrow.None);
  }

  static addAnyOf(builder: flatbuffers.Builder, anyOf: number) {
    builder.addFieldInt16(3, anyOf, 0);
  }

  static addAnyWidth(builder: flatbuffers.Builder, anyWidth: boolean) {
    builder.addFieldInt8(4, +anyWidth, +false);
  }

  static endScalarDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createScalarDecode(
    builder: flatbuffers.Builder,
    byteOrder: ByteOrder | null,
    widths: Widths,
    narrow: Narrow,
    anyOf: number,
    anyWidth: boolean,
  ): flatbuffers.Offset {
    ScalarDecode.startScalarDecode(builder);
    if (byteOrder !== null) ScalarDecode.addByteOrder(builder, byteOrder);
    ScalarDecode.addWidths(builder, widths);
    ScalarDecode.addNarrow(builder, narrow);
    ScalarDecode.addAnyOf(builder, anyOf);
    ScalarDecode.addAnyWidth(builder, anyWidth);
    return ScalarDecode.endScalarDecode(builder);
  }

  unpack(): ScalarDecodeT {
    return new ScalarDecodeT(
      this.byteOrder(),
      this.widths(),
      this.narrow(),
      this.anyOf(),
      this.anyWidth(),
    );
  }

  unpackTo(_o: ScalarDecodeT): void {
    _o.byteOrder = this.byteOrder();
    _o.widths = this.widths();
    _o.narrow = this.narrow();
    _o.anyOf = this.anyOf();
    _o.anyWidth = this.anyWidth();
  }

  unpackFields(...fields: string[]): ScalarDecodeT {
    const t = new ScalarDecodeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("byte_order")) {
      t.byteOrder = this.byteOrder();
    }
    if (fieldSet.has("widths")) {
      t.widths = this.widths();
    }
    if (fieldSet.has("narrow")) {
      t.narrow = this.narrow();
    }
    if (fieldSet.has("any_of")) {
      t.anyOf = this.anyOf();
    }
    if (fieldSet.has("any_width")) {
      t.anyWidth = this.anyWidth();
    }
    return t;
  }
}

export class ScalarDecodeT implements flatbuffers.IGeneratedObject {
  constructor(
    public byteOrder: ByteOrder | null = null,
    public widths: Widths = Widths.W1,
    public narrow: Narrow = Narrow.None,
    public anyOf: number = 0,
    public anyWidth: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ScalarDecode.createScalarDecode(
      builder,
      this.byteOrder,
      this.widths,
      this.narrow,
      this.anyOf,
      this.anyWidth,
    );
  }

  clone(): ScalarDecodeT {
    const obj = new ScalarDecodeT();
    obj.byteOrder = this.byteOrder;
    obj.widths = this.widths;
    obj.narrow = this.narrow;
    obj.anyOf = this.anyOf;
    obj.anyWidth = this.anyWidth;
    return obj;
  }

  equals(other: ScalarDecodeT): boolean {
    if (this.byteOrder !== other.byteOrder) return false;
    if (this.widths !== other.widths) return false;
    if (this.narrow !== other.narrow) return false;
    if (this.anyOf !== other.anyOf) return false;
    if (this.anyWidth !== other.anyWidth) return false;
    return true;
  }
}

export function verifyScalarDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 1);
  } finally {
    verifier.popDepth();
  }
}
